const VOID_ELEMENTS = new Set([
  'area',
  'base',
  'br',
  'col',
  'embed',
  'hr',
  'img',
  'input',
  'link',
  'meta',
  'param',
  'source',
  'track',
  'wbr'
])

export const convertH1ToDivTopic = (html: string): string => {
  let depth = 0

  return html.replace(
    /<(\/?)(\w+)([^>]*?)(\/?)>/gi,
    (match, slash, tag, _attrs, selfClose) => {
      const tagLower = tag.toLowerCase()
      const isClosing = slash === '/'
      const isSelfClosing = selfClose === '/' || VOID_ELEMENTS.has(tagLower)

      if (isSelfClosing) return match

      if (isClosing) {
        if (tagLower === 'h1' && depth === 0) return '</div>'
        depth--
        return match
      }

      if (tagLower === 'h1' && depth === 0) return '<div class="E-TOPICO">'

      depth++
      return match
    }
  )
}
